import React, { useContext } from 'react';
import './style.css';
// import { RiskOverviewContext } from '../../RiskOverview';
import ExpensesDatapoint from './ExpensesDatapoint/ExpensesDatapoint';
import { AreaDataContext } from '../../../PropertyExplorer';


const SeeMoreExpensesData = ({ propertyData }) => {
    // const { FEMAData } = useContext(RiskOverviewContext);
    const { geoData } = useContext(AreaDataContext);
  

    const census_tract = propertyData.data.property_details.census_tract
    const zip = propertyData.data.property_details.zip
    const fips = propertyData.data.property_details.fips
    const state = propertyData.data.property_details.state_short

    // Load the qgd local data from local storage, parse it, then get the data for the census_tract, zip, fips, and state
    // Load the qgd data from local storage
    // const qgdData = JSON.parse(localStorage.getItem('qgd'));

    // Get the fips and zip data from the qgd data
    // const fipsData = qgdData.fips[fips]
    // const zipData = qgdData.zip[zip]
    // const censusTractData = qgdData.census_tract[census_tract]
    // const stateData = qgdData.state[state]
    const fipsData = geoData.fips
    const zipData = geoData.zip
    const censusTractData = geoData.census_tract
    const stateData = geoData.state
    const FEMAData = fipsData.fema_data
    console.log('FEMAData', FEMAData)
    console.log('fips FEMA Data', fipsData.fema_data)

    const county_name = fipsData?.county_name

    // PULL THE DATA FROM THE VARIOUS SOURCES
    const fips_insurance_non_renewal_rate = FEMAData?.detailed_records?.insurance_non_renewals?.[0]?.non_renewal_rate
    const fips_insurance_non_renewal_rate_national_rank = FEMAData?.detailed_records?.insurance_non_renewals?.[0]?.national_non_renewal_rank
    const fips_insurance_non_renewal_rate_state_rank = FEMAData?.detailed_records?.insurance_non_renewals?.[0]?.state_non_renewal_rank

    const fips_nfip_claims_national_rank = FEMAData?.summary?.fema_nfip_claims_count_national_rank
    const fips_nfip_claims_payout_sum = FEMAData?.summary?.fema_nfip_claims_amountPaidOnBuildingClaim_sum
    const fips_nfip_claims_payout_sum_national_rank = FEMAData?.summary?.fema_nfip_claims_amountPaidOnBuildingClaim_sum_national_rank
    const fips_hazard_mitigation_grants_sum = FEMAData?.summary?.hazard_mitigation_actualAmountPaid_sum
    const fips_hazard_mitigation_grants_national_rank = FEMAData?.summary?.hazard_mitigation_actualAmountPaid_sum_national_rank
    const fips_hazard_mitigation_grants_list = FEMAData?.detailed_records?.hazard_mitigation || []
    const zip_hazard_mitigation_grants_count = fips_hazard_mitigation_grants_list.filter(item => item.zip === zip).length
    const fips_public_assistance_sum = FEMAData?.summary?.public_assistance_projectAmount_sum
    const fips_public_assistance_sum_national_rank = FEMAData?.summary?.public_assistance_projectAmount_sum_national_rank
    // Calculate the sum of the public assistance projects
    const fips_homeowner_assistance_sum = FEMAData?.summary?.housing_assistance_totalDamage_sum
    const fips_homeowner_assistance_sum_national_rank = FEMAData?.summary?.housing_assistance_totalDamage_sum_national_rank

    const femaPublicAssistanceRecords = FEMAData?.detailed_records?.public_assistance || []
    
    const fips_public_assistance_calculated_sum = femaPublicAssistanceRecords.reduce((acc, item) => acc + item.totalObligated, 0)
    const fips_public_assistance_calculated_sum_feds_covering = femaPublicAssistanceRecords.reduce((acc, item) => acc + item.federalShareObligated, 0)
    const fips_public_assistance_calculated_pct_feds_covering = (fips_public_assistance_calculated_sum_feds_covering / fips_public_assistance_calculated_sum) * 100

    const zip_hud_difficulty_status = zipData?.hud_difficult_dev_status
    const zip_insurance_vs_national_average = zipData?.insurance_cost_vs_national_avg

    const state_has_fair_plan = stateData?.fair_plan === "Yes"
    const state_insurance_three_year_growth_rate = stateData?.insurance_growth_3_yr
    const state_pct_households_on_fair_plan = stateData?.pct_of_households_on_fair_plan
    const state_pct_of_gov_rev_from_ret = stateData?.prop_tax_as_pct_of_state_revenue
    const state_ret_avg_vs_national = stateData?.state_vs_national_ret_avg
    
    const fips_national_rank_avg_total_ret_paid = fipsData?.fips_national_rank_avg_total_ret_paid
    
    
    const datapoints_for_display = [
        {
            geo: 'state',
            title: `Does ${state} have a Fair Plan?`,
            value: state_has_fair_plan,
            value_type: "boolean",
            subvalue: null,
            subvalue_type: null,
            about: "A FAIR Plan, or Fair Access to Insurance Requirements Plan, is a state-mandated program that provides basic property insurance to homeowners and businesses who cannot obtain coverage in the traditional insurance market, often due to high-risk factors like location."
        },
        {
            geo: 'state',
            title: `Percentage of Households on Fair Plan`,
            value: state_pct_households_on_fair_plan,
            value_type: "percentage",
            subvalue: null,
            subvalue_type: null,
        },
        {
            geo: 'state',
            title: `Homeowner Insurance Premiums Growth Over Last 3 Years`,
            value: state_insurance_three_year_growth_rate,
            value_type: "percentage",
            subvalue: null,
            subvalue_type: null,
        },
        {
            geo: 'state',
            title: `Percentage of Government Revenue from Property Taxes`,
            value: state_pct_of_gov_rev_from_ret,
            value_type: "percentage",
            subvalue: null,
            subvalue_type: null,
            about: "The higher amount of government revenue from property taxes, the more likely it is that property taxes may be raised to fund rebuild efforts after a climate event."
        },
        {
            geo: 'state',
            title: `Average Real Estate Taxes Paid Per Household`,
            value: fips_national_rank_avg_total_ret_paid,
            value_type: "rank",
            subvalue: null,
            subvalue_type: null,
        },
        {
            geo: 'fips',
            title: "Homeowner Insurance Non-Renewal Rate",
            value: fips_insurance_non_renewal_rate,
            value_type: "percentage",
            subvalue: fips_insurance_non_renewal_rate_national_rank,
            subvalue_type: "rank",
            about: "The insurance non-renewal rate is the percentage of homeowners insurance policies that were not renewed in the area."
        },
        {
            geo: 'fips',
            title: "NFIP Claims Paid Over Last 10 Years",
            value: fips_nfip_claims_payout_sum,
            value_type: "currency",
            subvalue: fips_nfip_claims_payout_sum_national_rank,
            subvalue_type: "rank",
            about: "The National Flood Insurance Program (NFIP) is a federal program, administered by FEMA, that provides affordable flood insurance to property owners in participating communities and encourages floodplain management to reduce future flood damage. "
        },
        {
            geo: 'fips',
            title: "FEMA Hazard Mitigation Grants Over Last 10 Years",
            value: fips_hazard_mitigation_grants_sum,
            value_type: "currency",
            subvalue: fips_hazard_mitigation_grants_national_rank,
            subvalue_type: "rank",
            about: "FEMA's hazard mitigation assistance provides funding for eligible long-term solutions that reduce the impact of disasters in the future. Mitigation planning and actions break the cycle of disaster damage, reconstruction, and repeated damage."
        },
        {
            geo: 'fips',
            title: "FEMA Homeowner Assistance Payouts Over Last 10 Years",
            value: fips_homeowner_assistance_sum,
            value_type: "currency",
            subvalue: fips_homeowner_assistance_sum_national_rank,
            subvalue_type: "rank",
            about: "FEMA's Individuals and Households Program (IHP) provides financial assistance to homeowners for home repair or replacement, as well as temporary housing assistance, if their primary residence is damaged or destroyed by a disaster in a declared area."
        },
        {
            geo: 'fips',
            title: "FEMA Public Assistance Payouts Over Last 10 Years",
            value: fips_public_assistance_sum,
            value_type: "currency",
            subvalue: fips_public_assistance_sum_national_rank,
            subvalue_type: "rank",
            about: "FEMA provides supplemental Federal disaster grant assistance for debris removal, emergency protective measures, and the repair, replacement, or restoration of disaster-damaged, publicly owned facilities"
        },
        {
            geo: 'zip',
            title: "Is this a HUD Difficult Development Area?",
            value: zip_hud_difficulty_status,
            value_type: "boolean",
            subvalue: null,
            subvalue_type: null,
            about: "Difficult Development Areas (DDA) are areas with high land, construction and utility costs relative to the area median income."
        },
        {
            geo: 'zip',
            title: "Avg. Insurance Cost vs National Average",
            value: zip_insurance_vs_national_average,
            value_type: "percentage",
            subvalue: null,
            subvalue_type: null,
        },
    ]

    // console.log("fips_insurance_non_renewal_rate", fips_insurance_non_renewal_rate)
    // console.log("fips_insurance_non_renewal_rate_national_rank", fips_insurance_non_renewal_rate_national_rank)
    // console.log("fips_insurance_non_renewal_rate_state_rank", fips_insurance_non_renewal_rate_state_rank)
    // console.log("fips_nfip_claims_national_rank", fips_nfip_claims_national_rank)
    // console.log("fips_hazard_mitigation_grants_national_rank", fips_hazard_mitigation_grants_national_rank)
    // console.log("zip_hazard_mitigation_grants_count", zip_hazard_mitigation_grants_count)
    // console.log("fips_public_assistance_sum", fips_public_assistance_sum.toLocaleString('en-US', { style: 'currency', currency: 'USD' }))
    // console.log("fips_public_assistance_sum_national_rank", fips_public_assistance_sum_national_rank)
    // console.log("fips_public_assistance_calculated_sum", fips_public_assistance_calculated_sum.toLocaleString('en-US', { style: 'currency', currency: 'USD' }))
    // console.log("fips_public_assistance_calculated_sum_feds_covering", fips_public_assistance_calculated_sum_feds_covering.toLocaleString('en-US', { style: 'currency', currency: 'USD' }))
    // console.log("fips_public_assistance_calculated_pct_feds_covering", fips_public_assistance_calculated_pct_feds_covering)
    // console.log("zip_hud_difficulty_status", zip_hud_difficulty_status)
    // console.log("zip_insurance_vs_national_average", zip_insurance_vs_national_average)
    // console.log("state_has_fair_plan", state_has_fair_plan)
    // console.log("state_insurance_three_year_growth_rate", state_insurance_three_year_growth_rate)
    // console.log("state_pct_households_on_fair_plan", state_pct_households_on_fair_plan)
    // console.log("state_pct_of_gov_rev_from_ret", state_pct_of_gov_rev_from_ret)
    // console.log("state_ret_avg_vs_national", state_ret_avg_vs_national)
    // console.log("fips_national_rank_avg_total_ret_paid", fips_national_rank_avg_total_ret_paid)
    // console.log(fipsData)
    // console.log(zipData)
    // console.log(censusTractData)
    // console.log(stateData)

    // console.log(FEMAData)
    // console.log(propertyData)

    const intro_sentence = "Below is a selection of some of the data points considered when modeling future recurring bills. Keep in mind, these may be weighed differently by location."

    return (
        <div className="see-more-expenses-data">
            <p className='text-align-center' dangerouslySetInnerHTML={{ __html: intro_sentence }} />
            <div className="expenses-data-grid">
                {datapoints_for_display.map((datapoint, index) => (
                    <ExpensesDatapoint 
                        key={index}
                        datapoint={datapoint}
                        county_name={county_name}
                        state={state}
                        zip={zip}
                    />
                ))}
            </div>
        </div>
    );
};

export default SeeMoreExpensesData;